import { Button, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
type Props = {
	isSubmitLoading: boolean;
	onHide: (proceed: boolean) => void;
	buttonColor?:
		| "inherit"
		| "primary"
		| "secondary"
		| "success"
		| "error"
		| "info"
		| "warning";
	buttonLabel?: "Delete" | "Save";
	className?: string;
};
export const FooterModalButtons = ({
	isSubmitLoading,
	onHide,
	buttonColor = "primary",
	buttonLabel = "Save",
	className,
}: Props) => {
	return (
		<Grid container spacing={2} justifyContent="flex-end">
			<Grid size={{ xs: 12, md: 3 }} style={{ margin: 0 }}>
				<Button
					fullWidth
					variant="contained"
					color="inherit"
					onClick={() => onHide(false)}
					className={className}
					size="small"
				>
					Cancel
				</Button>
			</Grid>
			<Grid size={{ xs: 12, md: 3 }} style={{ margin: 0 }}>
				<Button
					fullWidth
					startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
					disabled={isSubmitLoading}
					variant="contained"
					color={buttonColor}
					type="submit"
					className={className}
					size="small"
				>
					{buttonLabel}
				</Button>
			</Grid>
		</Grid>
	);
};
